// import { logEvent } from '@firebase/analytics';
// import { firebaseAnalytics } from '../firebase';
import getTimezone from '../timezone';
import { queueReportClick } from './reportQueue';
import type { EBiz } from './report_biz';
import type { ReportKeys } from './type';

// 通过 枚举 限定上报的 key，方便管理
// 必须在此文档记录：https://mindverse.feishu.cn/sheets/DoVIsBeBVhdtiFtZZgVcWbVanXh
export enum EReportClickKey {
  login = 'login',
  login_error = 'login_error',
  login_success = 'login_success',
  logout = 'logout',

  sign_up = 'sign_up',
  verify_email = 'verify_email',
  forget_password = 'forget_password',
  reset_password = 'reset_password',

  click_voice_switch = 'click_voice_switch',
  click_select_voice = 'click_select_voice',
  click_try_voice = 'click_try_voice',

  click_memory_add_table = 'click_memory_add_table',
  click_how_to_use_memory = 'click_how_to_use_memory',

  click_mute_voice = 'click_mute_voice',
  click_mute_avatar = 'click_mute_avatar',
  click_user_first_sentences = 'click_user_first_sentences',

  click_share_copy_link = 'click_share_copy_link',
  click_share_to_twitter = 'click_share_to_twitter',

  click_portfolio_try = 'click_portfolio_try',
  click_portfolio_link = 'click_portfolio_link',

  clicked_empty = 'clicked_empty',

  clicked_layout_top_bar = 'header_clicked',
  clicked_ability_switch = 'ability_switch_clicked',
  clicked_ability_auth = 'ability_auth_clicked',

  clicked_pa_knowledge_add = 'pa_knowledge_add_clicked',

  start_expose_clicked = 'start_expose_clicked',

  pa_start_clicked = 'pa_start_clicked',
  pa_create_clicked = 'pa_create_clicked',
  pa_create_skip = 'pa_create_skip',
  pa_create_crash = 'pa_create_crash',

  onboarding_add_clicked = 'onboarding_add_clicked',

  landing_redirect = 'landing_redirect',

  clicked_full_screen = 'clicked_full_screen',
  clicked_hide_screen = 'clicked_hide_screen',

  search_result_click = 'search_result_click',

  add_types_clicked = 'add_types_clicked',
  add_types_saved = 'add_types_saved',

  cvn_clicked = 'cvn_clicked',

  serendipity_click = 'serendipity_click',
  serendipity_memory_save = 'serendipity_memory_save',
  serendipity_chat_topic_click = 'serendipity_chat_topic_click',

  open_in_app_clicked = 'open_in_app_clicked',
  memory_share_clicked = 'memory_share_clicked',
  chat_share_clicked = 'chat_share_clicked',

  topic_suggestion_clicked = 'topic_suggestion_clicked',
  chat_about_this_clicked = 'chat_about_this_clicked',
  connected_memory_clicked = 'connected_memory_clicked',

  guide_clicked = 'guide_clicked',
  guide_start_clicked = 'guide_start_clicked',

  ai_home_share_clicked = 'ai_home_share',
  homepage_ice_break_clicked = 'homepage_ice_break_clicked',

  homepage_cover_upload = 'homepage_cover_upload',
  homepage_cover_upload_failed = 'homepage_cover_upload_failed',

  get_app_clicked = 'get_app_clicked'
}

export default function reportClick(key: EReportClickKey, params?: ReportKeys, biz?: EBiz): void {
  const searchParams = new URLSearchParams(window.location.search);
  const timezone = getTimezone();

  // 为了以防万一，默认使用 key10 填写 biz 的值，防止被占用
  const newParams: ReportKeys = {
    key10: biz,
    ...(timezone ? { timezone } : {}),
    ...(searchParams.get('utm_source')
      ? { utm_source: searchParams.get('utm_source') || undefined }
      : {}),
    ...(searchParams.get('utm_medium')
      ? { utm_medium: searchParams.get('utm_medium') || undefined }
      : {}),
    ...(searchParams.get('utm_campaign')
      ? { utm_campaign: searchParams.get('utm_campaign') || undefined }
      : {}),
    ...(params || {})
  };

  // 上报到 tracker
  queueReportClick(key, newParams);
  // 上报到 firebase
  // logEvent(firebaseAnalytics(), key as string, newParams);
}
